import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { PageService } from '../../../../services/page.service';
import { OrderTypes } from '../../../../enums/order-types';
import { Router } from '@angular/router';
import { ContentService } from '../../../../services/content.service';
import {
  customRequestUserGuideUrl,
  PERCH_USER_GUIDE_URL,
} from '../../../../shared/user-guides';

@Component({
  selector: 'app-mobile-navigation-menu',
  templateUrl: './mobile-navigation-menu.component.html',
  styleUrls: ['./mobile-navigation-menu.component.scss'],
  standalone: false,
})
export class MobileNavigationMenuComponent implements OnInit {
  @Input() visible = false;
  @Output() onBWProductsClicked = new EventEmitter<void>();
  @Output() onBWProgramsClicked = new EventEmitter<void>();
  @Output() onODProductsClicked = new EventEmitter<void>();
  @Output() onODProgramsClicked = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  buyingWindowMenuExpanded = false;
  onDemandMenuExpanded = false;
  accountMenuExpanded = false;
  supportMenuExpanded = false;

  constructor(
    private authService: AuthService,
    private pageService: PageService,
    private router: Router,
    private contentService: ContentService
  ) {}

  ngOnInit(): void {
    if (this.canSeeClearance) {
      this.contentService.getClearanceUrl();
    }
    if (this.canSeeTruckGraphics) {
      this.contentService.getTruckGraphicsUrl();
    }

    // fetch  sustainability content
    this.contentService.getSustainabilityItems();

    if (this.canSeeRepack) {
      this.contentService.getRepackUrl();
    }
  }

  bwProductsClicked() {
    this.onBWProductsClicked.emit();
    this.onClosed();
    return false;
  }

  navigateToODQuickOrder() {
    this.pageService.setQuickOrderTab(OrderTypes.ECOMMERCE_TYPE);
    this.router.navigate(['/quick-order']);
    this.onClosed();
    return false;

    this.onClosed();
    return false;
  }

  navigateToBWQuickOrder() {
    this.pageService.setQuickOrderTab(OrderTypes.PREORDER_TYPE);
    this.router.navigate(['/quick-order']);
    this.onClosed();
    return false;
  }

  bwProgramsClicked() {
    this.onBWProgramsClicked.emit();
    this.onClosed();
    return false;
  }

  odProductsClicked() {
    this.onODProductsClicked.emit();
    this.onClosed();
    return false;
  }

  odProgramsClicked() {
    this.onODProgramsClicked.emit();
    this.onClosed();
    return false;
  }

  onClosed() {
    this.closed.emit();
  }

  readonly perchUserGuideUrl = PERCH_USER_GUIDE_URL;

  get customRequestUserGuideUrl(): string {
    return customRequestUserGuideUrl(this.isWslrUser);
  }

  get canOrder(): boolean {
    return this.authService.canOrder;
  }

  get canSeeBuyingWindows(): boolean {
    return this.authService.canBuyingWindow && this.canOrder;
  }
  get canShowTransaction(): boolean {
    return this.authService.canSeeTransactions;
  }

  get canShowPaymentPage(): boolean {
    return this.authService.canSeePaymentMethods;
  }

  get canShowBudgets(): boolean {
    return this.authService.canSeeBudgets;
  }

  get canShowCustomRequest(): boolean {
    return this.authService.canCustomRequest;
  }

  get canSeeOrders(): boolean {
    return this.authService.canSeeOrders;
  }

  get canSeeAddresses(): boolean {
    return this.authService.canSeeAddresses;
  }

  get canSeeRepairRequests(): boolean {
    return this.authService.canSeeRepairRequests;
  }

  get isWslrUser(): boolean {
    return this.authService.isOneOfWholesaler;
  }

  get canSeeClearance(): boolean {
    return this.authService.canSeeClearance;
  }

  get canSeeTruckGraphics(): boolean {
    return this.authService.canSeeTruckGraphics;
  }

  get canSeeRepack(): boolean {
    return this.authService.canSeeRepack;
  }

  get canSeeReports(): boolean {
    return this.authService.canSeeReports;
  }

  get clearanceUrl(): string {
    return this.contentService.clearanceUrl;
  }

  get truckGraphicsUrl(): string {
    return this.contentService.truckGraphicsUrl;
  }

  get repackUrl(): string {
    return this.contentService.repackUrl;
  }

  navigateToClearance() {
    this.onClosed();
    this.router.navigate([this.clearanceUrl]);
  }

  navigateToTruckGraphics() {
    this.onClosed();
    this.router.navigate([this.truckGraphicsUrl]);
  }

  navigateToRepack() {
    this.onClosed();
    this.router.navigate([this.repackUrl]);
  }
}
